// extracted by mini-css-extract-plugin
export var breadcrumb = "_18-3";
export var breadcrumbArrow = "_18-4";
export var breadcrumbs = "_18-0";
export var link = "_18-5";
export var sm = "_18-1";
export var xs = "_18-2";